export const REBATEGROUP_MODULE_KEY = 'rebategroups';
